import React from 'react';
import { Search, Filter, ChevronDown } from 'lucide-react';
import { LoanStatus, QuickFilter } from '../types';
interface ControlBarProps {
  searchQuery: string;
  setSearchQuery: (q: string) => void;
  statusFilter: LoanStatus;
  setStatusFilter: (s: LoanStatus) => void;
  activeQuickFilter: QuickFilter;
  setActiveQuickFilter: (f: QuickFilter) => void;
}
export function ControlBar({
  searchQuery,
  setSearchQuery,
  statusFilter,
  setStatusFilter,
  activeQuickFilter,
  setActiveQuickFilter
}: ControlBarProps) {
  const quickFilters: QuickFilter[] = ['Closing Soon', 'Lock Expiring', 'High Loan Amount'];
  return <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 mb-5" data-id="element-48">
      <div className="flex items-center gap-2.5 flex-1" data-id="element-49">
        <div className="relative flex-1 max-w-sm" data-id="element-50">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" data-id="element-51" />
          <input type="text" placeholder="Search borrower, loan name, or ID..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full h-9 pl-9 pr-4 bg-white border border-gray-200 rounded-lg text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 focus:ring-offset-0 transition-all shadow-sm" data-id="element-52" />
        </div>

        <div className="relative" data-id="element-53">
          <select value={statusFilter} onChange={e => setStatusFilter(e.target.value as LoanStatus)} className="appearance-none h-9 pl-3 pr-9 bg-white border border-gray-200 rounded-lg text-sm font-medium text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 focus:ring-offset-0 shadow-sm cursor-pointer" data-id="element-54">
            <option value="Open" data-id="element-55">Open Escalations</option>
            <option value="Closed" data-id="element-56">Closed Escalations</option>
          </select>
          <ChevronDown className="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" data-id="element-57" />
        </div>
      </div>

      <div className="flex items-center gap-2 overflow-x-auto hide-scrollbar" data-id="element-58">
        <div className="flex items-center gap-1.5 text-gray-400 mr-1 flex-shrink-0" data-id="element-59">
          <Filter className="w-3.5 h-3.5" data-id="element-60" />
        </div>
        {quickFilters.map(filter => <button key={filter} onClick={() => setActiveQuickFilter(activeQuickFilter === filter ? null : filter)} className={`whitespace-nowrap px-3 py-1.5 rounded-full text-xs font-medium transition-all border ${activeQuickFilter === filter ? 'bg-gray-900 text-white border-gray-900 shadow-sm' : 'bg-white text-gray-600 border-gray-200 hover:bg-gray-50 hover:border-gray-300'}`} data-id="element-61">
            {filter}
          </button>)}
      </div>
    </div>;
}